module.exports = __webpack_public_path__ + "img/libu-android-download.156c9866.png";